
// project imports
import { lazy } from 'react';
import HomePage from '../website/pages/HomePage';
import About from '../website/pages/About';
import Blogs from '../website/pages/Blogs';
import BlogDetails from '../website/pages/BlogDetail';
import BikeRent from '../website/pages/BikeRent';
import HowItWorks from '../website/pages/HowItWorks';
const BlogCategories = lazy(() => import('../website/pages/BlogCategories'));

// ==============================|| MAIN ROUTING ||============================== //

const WebsiteRoutes = {
       path: '/',
       children: [
         {
           index: true,
           element: <HomePage />
         },
         {
           path: 'blogs',
           element: <BlogCategories />,
         },
         {
           path: 'about-us',
           element: <About />
         },
          {
               path:"/blogs/:blogType",
                element: <Blogs />
          },
          {
            path: 'blogs/:blogType/:slug',
            element: <BlogDetails />
          },
          {
            path: 'rent/bike',
            element: <BikeRent />
          },
          {
            path: 'how-motourax-works',
            element: <HowItWorks />
          }
       ]
     };

export default WebsiteRoutes;
